import { createAsyncThunk } from '@reduxjs/toolkit'
import MediaQualityAssuranceSettings from './media-quality-assurance-settings-model'
import {
  delete_mediaQualityAssuranceSettings,
  load_mediaQualityAssuranceSettingss,
  store_mediaQualityAssuranceSettings,
} from './mediaQualityAssuranceSettings-service'

export const LoadMediaQualityAssuranceSettingssAsync = createAsyncThunk<
  any,
  any
>(
  'composer/load/mediaQualityAssuranceSettings',
  async (params: { uid: string }) => {
    return await load_mediaQualityAssuranceSettingss(params)
  },
)

export const CreateMediaQualityAssuranceSettingsAsync = createAsyncThunk<
  any,
  any
>(
  'composer/create/mediaQualityAssuranceSettings',
  async (params: MediaQualityAssuranceSettings) => {
    return await store_mediaQualityAssuranceSettings(params)
  },
)

export const DeleteMediaQualityAssuranceSettingsAsync = createAsyncThunk<
  any,
  any
>('composer/delete/mediaQualityAssuranceSettings', async (params) => {
  return await delete_mediaQualityAssuranceSettings(params)
})
